import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";

const debug = initDebugger('scrollIntoView');
type ElementEllerCssSelector = HTMLElement | string | null;

/** scroller slik at angitt element er i senter av vinduet*/
export function scrollTilSenter(element: ElementEllerCssSelector, forsinkelseMillis = 0) {
    scrollTil(element, forsinkelseMillis, {block: 'center', behavior: 'smooth'});
}

export function scrollTilNærmestAvToppBunn(element: ElementEllerCssSelector, forsinkelseMillis = 0) {
    scrollTil(element, forsinkelseMillis, {block: 'nearest', behavior: 'smooth'});
}

/** scroller slik at toppen av element kommer nærmest toppen av scroll-kontainer */
export function scrollTilTopp(element: ElementEllerCssSelector, forsinkelseMillis = 0) {
    scrollTil(element, forsinkelseMillis, {block: 'start', behavior: 'smooth'});
}

/** scroller slik at bunnen av element kommer nærmest bunn av scroll-kontainer */
export function scrollTilBunn(element: ElementEllerCssSelector, forsinkelseMillis = 0) {
    scrollTil(element, forsinkelseMillis, {block: 'end', behavior: 'smooth'});
}

/** scroller elementet slik at det blir synlig dersom elementet ikke er synlig før scrolling.
 * Merk at vi benytter en ikke-standardisert metode element.scrollIntoViewIfNeeded,
 * se https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded#browser_compatibility */
export function scrollDersomNødvendig(element: ElementEllerCssSelector, forsinkelseMillis = 0) {
    const utførScroll = () => {
        const e = somElement(element) as HTMLElementMedScrollIntoViewIfNeeded;
        if (erNil(e)) return;
        if (erIkkeNil(e.scrollIntoViewIfNeeded)) {
            debug('utfører element.scrollIntoViewIfNeeded', element);
            e.scrollIntoViewIfNeeded()
        } else
            scrollTilNærmestAvToppBunn(e);
    }
    if (forsinkelseMillis == 0) utførScroll();
    else window.setTimeout(() => utførScroll(), forsinkelseMillis);
}

//hjelpemetoder

export function scrollTil(element: ElementEllerCssSelector, forsinkelseMillis: number, valg: ScrollIntoViewOptions) {
    debug('skedulerer element.scrollIntoView %s', forsinkelseMillis, element);
    if (forsinkelseMillis == 0) scrollIntoView(element, valg);
    else window.setTimeout(() => scrollIntoView(element, valg), forsinkelseMillis);
}

function somElement(element: ElementEllerCssSelector) {
    if (typeof element === 'string')
        return document.querySelector(element);
    return element;
}

function scrollIntoView(element: ElementEllerCssSelector, valg: ScrollIntoViewOptions) {
    const e = somElement(element);
    if (erNil(e)) return;
    debug('utfører element.scrollIntoView', element);
    e.scrollIntoView(valg);
}

type HTMLElementMedScrollIntoViewIfNeeded = HTMLElement & { scrollIntoViewIfNeeded(centerIfNeeded?:boolean):void}
